import { HStack, InputGroup, InputRightElement, IconButton } from '@chakra-ui/react';
import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoClose, IoSearchSharp } from 'react-icons/io5';
import { SearchTags } from './SearchTags';

export const GlobalSearch = () => {
    const navigate = useNavigate();
    const [searchInputValue, setSearchInputValue] = useState('');
    const [showSuggestion, setShowSuggestion] = useState(false);
    const searchContainerRef = useRef(null);
    const searchTagsRef = useRef(null);

    const handleSearch = (value) => {
        // This can be used for any search-related logic
        console.log('Search value:', value);
    };

    const handleNavigateSearch = (query) => {
        // Navigate to search results page
        navigate(`/search/research-centre/library?query=${encodeURIComponent(query)}`);
    };

    const handleSearchClose = () => {
        setShowSuggestion(false);
        setSearchInputValue('');
    };

    const handleReset = () => {
        setSearchInputValue('');
        setShowSuggestion(false);
    };

    // Close suggestions when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
                setShowSuggestion(false);
            }
        };

        if (showSuggestion) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showSuggestion]);

    return (
        <HStack 
            display={{ base: "none", md: "flex" }}
            marginTop={"0px!important"}
            px="2"
            position="relative"
            ref={searchContainerRef}
        >
            <InputGroup 
                size="md"
                position="relative"
                borderRadius="lg"
                bg="white"
                border="1px solid"
                borderColor="color.lightgray4"
                _hover={{
                    borderColor: "color.blue",
                    boxShadow: "0 0 0 1px rgba(3, 93, 161, 0.1)"
                }}
                _focusWithin={{
                    borderColor: "color.blue",
                    boxShadow: "0 0 0 3px rgba(3, 93, 161, 0.1)"
                }}
                transition="all 0.2s ease-in-out"
                boxShadow="sm"
            >
                <SearchTags
                    handleSearch={handleSearch}
                    naviagateSearch={handleNavigateSearch}
                    showSuggestion={showSuggestion}
                    setShowSuggestion={setShowSuggestion}
                    inputValue={searchInputValue}
                    setInputValue={setSearchInputValue}
                    onSearchClose={handleSearchClose}
                    ref={searchTagsRef}
                />
                <InputRightElement 
                    width="3rem" 
                    pointerEvents="auto"
                    pr={2}
                >
                    {searchInputValue && searchInputValue.length > 0 ? (
                        <IconButton
                            aria-label="Clear search"
                            icon={<IoClose />}
                            size="sm"
                            variant="ghost"
                            colorScheme="gray"
                            onClick={handleReset}
                            borderRadius="md"
                            fontSize="18px"
                            color="color.lightgray2"
                            _hover={{
                                color: "color.red",
                                bg: "red.50",
                                transform: "scale(1.1)"
                            }}
                            _active={{
                                transform: "scale(0.95)"
                            }}
                            transition="all 0.2s ease-in-out"
                        />
                    ) : (
                        <IconButton
                            aria-label="Search"
                            icon={<IoSearchSharp />}
                            size="sm"
                            variant="ghost"
                            colorScheme="blue"
                            onClick={() => handleNavigateSearch(searchInputValue)}
                            borderRadius="md"
                            fontSize="18px"
                            color="color.lightgray2"
                            _hover={{
                                color: "color.blue",
                                bg: "blue.50",
                                transform: "scale(1.1)"
                            }}
                            _active={{
                                transform: "scale(0.95)"
                            }}
                            transition="all 0.2s ease-in-out"
                        />
                    )}
                </InputRightElement>
            </InputGroup>
        </HStack>
    );
};

